import React from 'react';
import {useControllerProps} from '../../ControllerContext';
import {CartItem} from './CartItem/CartItem';

export enum CartItemsDataHook {
  'root' = 'CartItemsDataHook.root',
  'item' = 'CartItemsDataHook.item',
}

export function CartItems() {
  const {items} = useControllerProps().cartStore.cart;

  return (
    <div data-hook={CartItemsDataHook.root}>
      <ul>
        {items.map((item) => (
          <li key={`cart-item-${item.cartItemId}`} data-hook={CartItemsDataHook.item}>
            <CartItem item={item} />
          </li>
        ))}
      </ul>
    </div>
  );
}
